import React from 'react';
import './ArrowLink.scss';
import {Link} from "react-router-dom";

const ArrowLink = ({children, ...linkProps}) => {
  return (
    <Link className={linkProps.type==="cta" ? "gcap-cta": "btn btn-secondary btn-icon"} {...linkProps} data-testid={"ArrowLink"}>
      <span>{children}</span>
      <i className="gc-icon-functional-arrow-right" aria-hidden="true"></i>
    </Link>
  )
};

ArrowLink.propTypes = {};

export default ArrowLink;
